import client, { endpoints } from '../api/client';
import { AUTH } from '../constants/actionTypes';

const errMsg = (e) => e?.response?.data?.error || e?.message || 'Unknown error.';

export const login = (email, password) => async (dispatch) => {
  dispatch({ type: AUTH.LOGIN_REQUEST });
  try {
    const { data } = await client.post(endpoints.auth.login, { email, password });
    localStorage.setItem('auth_token', data.token);
    dispatch({ type: AUTH.LOGIN_SUCCESS, payload: data.user });
    dispatch({ type: AUTH.CAPS_SUCCESS, payload: data.capabilities || [] });
    return { ok: true };
  } catch (e) {
    dispatch({ type: AUTH.LOGIN_FAILURE, payload: errMsg(e) });
    return { ok: false, error: errMsg(e) };
  }
};

export const signup = (email, password, name, username) => async (dispatch) => {
  dispatch({ type: AUTH.LOGIN_REQUEST });
  try {
    const { data } = await client.post(endpoints.auth.signup, { email, password, name, username });
    localStorage.setItem('auth_token', data.token);
    dispatch({ type: AUTH.LOGIN_SUCCESS, payload: data.user });
    dispatch({ type: AUTH.CAPS_SUCCESS, payload: data.capabilities || [] });
    return { ok: true };
  } catch (e) {
    dispatch({ type: AUTH.LOGIN_FAILURE, payload: errMsg(e) });
    return { ok: false, error: errMsg(e) };
  }
};

export const loadMe = () => async (dispatch) => {
  const t = localStorage.getItem('auth_token');
  if (!t) return;
  try {
    const { data } = await client.get(endpoints.auth.me);
    dispatch({ type: AUTH.ME_SUCCESS, payload: data.user });
    dispatch({ type: AUTH.CAPS_SUCCESS, payload: data.capabilities || [] });
  } catch { /* interceptor clears the token on 401 */ }
};

export const updateMyProfile = (patch) => async (dispatch) => {
  try {
    const { data } = await client.put(endpoints.auth.me, patch);
    dispatch({ type: AUTH.ME_SUCCESS, payload: data.user });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const changePassword = (current, next) => async () => {
  try {
    await client.post(endpoints.auth.changePassword, { current, next });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const requestPasswordReset = (email) => async () => {
  try { await client.post(endpoints.auth.requestPasswordReset, { email }); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const resetPassword = (token, password) => async (dispatch) => {
  try {
    const { data } = await client.post(endpoints.auth.resetPassword, { token, password });
    if (data.token) localStorage.setItem('auth_token', data.token);
    if (data.user) dispatch({ type: AUTH.LOGIN_SUCCESS, payload: data.user });
    return { ok: true };
  } catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const verifyEmail = (token) => async () => {
  try { await client.get(endpoints.auth.verifyEmail(token)); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const resendVerification = () => async () => {
  try { await client.post(endpoints.auth.resendVerification); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const deleteSelf = () => async (dispatch) => {
  try { await client.delete(endpoints.auth.deleteSelf); dispatch(logout()); return { ok: true }; }
  catch (e) { return { ok: false, error: errMsg(e) }; }
};

export const logout = () => (dispatch) => {
  client.post(endpoints.auth.logout).catch(() => {});
  localStorage.removeItem('auth_token');
  dispatch({ type: AUTH.LOGOUT });
};
